import React from 'react'

import { useIsUnauthenticatedClient } from '@/components/flows/CompassFlow/hooks/useIsUnauthenticatedClient'
import AuthGuard from '@/components/guards/AuthGuard'

interface Props {
  children: React.ReactNode
}

// Use for pages where user must either be authenticated or have a valid
// Compass invite token
const CompassGuard: React.FC<Props> = ({ children }) => {
  const isClient = useIsUnauthenticatedClient()

  // If the user is a client, they can access without needing to authenticate
  return isClient ? <>{children}</> : <AuthGuard>{children}</AuthGuard>
}

export default CompassGuard
